import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsOfficesGroup } from "../@hooks"


export default function UserSettingOfficesGroupTabButton() {
    const { handleSetOfficesGroupFormData } = useUserSettingsOfficesGroup()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetOfficesGroupFormData}
    >
        Define Offices Group
    </ButtonLoadingSeeker>
}